import React, { useEffect } from "react";
import Style from "../Style/AboutSkill.module.scss";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const AboutSkill = ({ darkMode }) => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className={`${Style.AboutSkill} ${darkMode ? Style.dark : ""}`}>
      <div className={Style.SkillBannerContent}>
        <div className={Style.wrapper}>
          <div className={Style.AboutSkillTop}>
            <h4 data-aos="zoom-in">About Us</h4>
          </div>

          <div className={Style.Aboutcontent}>
            <div
              className={Style.Aboutleft}
              data-aos="zoom-in-up"
              data-aos-delay="100"
            >
              <h2>
                Welcome To Optimyz Learning For <br /> Skills Training
              </h2>
              <p>
                At Optimyz Learning, we are passionate about helping individuals
                transform from within — through powerful communication,
                authentic presence, and future-ready skills.
              </p>
              <p>
                A confident <strong>YOU</strong> begins here.
              </p>
              <div className={Style.AboutExplore}>
                <Link to="/about-us">Explore More</Link>
              </div>
            </div>
            <div
              className={Style.Aboutright}
              data-aos="zoom-in-down"
              data-aos-delay="300"
            >
              <div className={Style.shapes}>
                <span className={Style.circle}></span>
                <span className={Style.triangle}></span>
                <span className={Style.dots}></span>
              </div>
              <img
                src="https://static.vecteezy.com/system/resources/previews/023/218/474/original/laptop-with-graduation-cap-and-books-on-wooden-table-against-gradient-background-ai-generate-free-photo.jpg"
                alt="Optimyz Training"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSkill;
